import { render, staticRenderFns } from "./PerfilAplicacaoComponent.vue?vue&type=template&id=2ab98b20"
import script from "./PerfilAplicacaoComponent.vue?vue&type=script&lang=js"
export * from "./PerfilAplicacaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports